import { Routes, Route } from "react-router-dom";
import Home from "../pages/home";
import ShowcaseLayout from "../layout/ShowcaseLayout";
import MainLayout from "../layout/MainLayout";
import ShowcaseButtons from "../pages/showcase/ShowcaseButtons";
import ShowcaseTextbox from "../pages/showcase/ShowcaseTextbox";
import ShowcaseDropdown from "../pages/showcase/ShowcaseDropdown";
import ShowcaseAccordion from "../pages/showcase/ShowcaseAccordion";
import ShowcaseTabs from "../pages/showcase/ShowcaseTabs";
import ShowcasePagination from "../pages/showcase/ShowcasePagination";
import ShowcaseRadio from "../pages/showcase/ShowcaseRadio";
import ShowcaseLabelNSupportingText from "../pages/showcase/ShowcaseLabelNSupportingText";
import Stashboard from "../pages/cms/Stashboard";
import Blocks from "../pages/cms/Blocks";
import ViewBlock from "../pages/cms/ViewBlock";
import ShowcaseIcons from "../pages/showcase/ShowcaseIcons";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Main Site Routes */}
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Stashboard />} />
        <Route path="blocks" element={<Blocks />} />
        <Route path="blocks/view" element={<ViewBlock />} />
      </Route>

      {/* Showcase Routes */}
      <Route path="/showcase/" element={<ShowcaseLayout />}>
        <Route path="" element={<Home />} />
        <Route path="buttons" element={<ShowcaseButtons />} />
        <Route path="textbox" element={<ShowcaseTextbox />} />
        <Route path="dropdown" element={<ShowcaseDropdown />} />
        <Route path="accordion" element={<ShowcaseAccordion />} />
        <Route path="tabsBreadcrumb" element={<ShowcaseTabs />} />
        <Route path="pagination" element={<ShowcasePagination />} />
        <Route path="radioButtonCheckbox" element={<ShowcaseRadio />} />
        <Route
          path="ShowcaseLabelNSupportingText"
          element={<ShowcaseLabelNSupportingText />}
        />
        <Route path="ShowcaseIcons" element={<ShowcaseIcons />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
